/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TriggerConditionResponseDto } from './TriggerConditionResponseDto';
import {
    TriggerConditionResponseDtoFromJSON,
    TriggerConditionResponseDtoFromJSONTyped,
    TriggerConditionResponseDtoToJSON,
    TriggerConditionResponseDtoToJSONTyped,
} from './TriggerConditionResponseDto';

/**
 * 
 * @export
 * @interface TriggerResponseDto
 */
export interface TriggerResponseDto {
    /**
     * 
     * @type {string}
     * @memberof TriggerResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerResponseDto
     */
    basis: TriggerResponseDtoBasisEnum;
    /**
     * 
     * @type {string}
     * @memberof TriggerResponseDto
     */
    createdById?: string | null;
    /**
     * 
     * @type {Array<TriggerConditionResponseDto>}
     * @memberof TriggerResponseDto
     */
    conditions: Array<TriggerConditionResponseDto>;
    /**
     * 
     * @type {Date}
     * @memberof TriggerResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof TriggerResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const TriggerResponseDtoBasisEnum = {
    Floating: 'FLOATING',
    Fixed: 'FIXED'
} as const;
export type TriggerResponseDtoBasisEnum = typeof TriggerResponseDtoBasisEnum[keyof typeof TriggerResponseDtoBasisEnum];


/**
 * Check if a given object implements the TriggerResponseDto interface.
 */
export function instanceOfTriggerResponseDto(value: object): value is TriggerResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('basis' in value) || value['basis'] === undefined) return false;
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TriggerResponseDtoFromJSON(json: any): TriggerResponseDto {
    return TriggerResponseDtoFromJSONTyped(json, false);
}

export function TriggerResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'basis': json['basis'],
        'createdById': json['createdById'] == null ? undefined : json['createdById'],
        'conditions': ((json['conditions'] as Array<any>).map(TriggerConditionResponseDtoFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function TriggerResponseDtoToJSON(json: any): TriggerResponseDto {
    return TriggerResponseDtoToJSONTyped(json, false);
}

export function TriggerResponseDtoToJSONTyped(value?: TriggerResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'basis': value['basis'],
        'createdById': value['createdById'],
        'conditions': ((value['conditions'] as Array<any>).map(TriggerConditionResponseDtoToJSON)),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

